import axios from 'axios';
import {API_BASE_URL} from "../helper/env";
import { getLocalAuthToken } from "../helper/utils";

export const exportFile = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + '/' + url, {
      params,
      headers: {}
    })
      .then(res => {
        console.log(res.data);
        if (res.data.error) {
          reject(res.data.error)
        } else {
          resolve(res.data)
        }
      })
      .catch(err => {
        reject('Something went wrong')
      })
  })
}

export const getList = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/` + url, {
      params,
      headers: {
        Authorization: authData?.token
      }
    }).then(res => {
      if (!res?.data?.success) {
        reject(res.data.message)
      } else {
        resolve(res?.data?.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getData = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/` + url, {
      params,
      headers: {
        Authorization: authData?.token
      }
    }).then(res => {
      if (!res?.data?.success) {
        reject(res.data.message)
      } else {
        resolve(res?.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const putData = (url,data) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + `/` + url, data, {
      headers: {
        Authorization: authData?.token
      }
    }).then(res => {
      if (!res?.data?.success) {
        reject(res.data.message)
      } else {
        resolve(res?.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getLocations = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/` + url, {
      params,
      headers: {Authorization: authData?.token}
    }).then(res => {
      if (res.data.success) {
        resolve(res.data.data)
      } else {
        reject(res.data.message)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getThanas = params => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/thanas/search`, {
      params,
      headers: {Authorization: authData?.token}
    }).then(res => {
      if (res.data.success) {
        resolve(res.data.data)
      } else {
        reject(res.data.message)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getAreas = params => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/areas/search`, {
      params,
      headers: {Authorization: authData?.token}
    }).then(res => {
      if (res.data.success) {
        resolve(res.data.data)
      } else {
        reject(res.data.message)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getDetails = (url, id) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/` + url + `/` + id, {
      headers: {Authorization: authData?.token}
    }).then(res => {
      if (res?.data?.success) {
        resolve(res?.data)
      } else {
        reject(res.data.message)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const deleteData = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.delete(`${API_BASE_URL}/${url}`, {
      params,
      headers: {Authorization: authData?.token}
    })
      .then(res => {
        if (!res?.data?.success) {
          reject(res.data.message)
        } else {
          resolve(res?.data)
        }
      })
      .catch(err => {
        reject(err.message)
      })
  })
}

export const destroy = (url, id) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.delete(`${API_BASE_URL}/${url}/${id}`, {
      headers: {Authorization: authData?.token}
    })
      .then(res => {
        if (!res?.data?.success) {
          reject(res.data.message)
        } else {
          resolve(res?.data)
        }
      })
      .catch(err => {
        reject(err.message)
      })
  })
}

export const getPaginatedList = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/` + url , {
      params,
      headers: {
        Authorization: authData?.token
      }
    }).then(res => {
      if (!res.data.success) {
        reject(res.data.message)
      } else {
        resolve(res)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const postData = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.post(API_BASE_URL + `/` + url , params,{
      headers: {
        Authorization: authData?.token
      }
    }).then(res => {
      if (!res?.data?.success) {
        reject(res.data.message)
      } else {
        resolve(res?.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}
